import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

const dataInicial = {
    solicitudesDev: [],
}

const GET_SOLICITUDES_DEV = 'GET_SOLICITUDES_DEV'
const PUT_SOLICITUDES_DEV = 'PUT_SOLICITUDES_DEV'
const GET_CLIENTES_DEV = 'GET_CLIENTES_DEV'
const PUT_CLIENTES_DEV = 'PUT_CLIENTES_DEV'
const GET_RELACIONES_DEV = 'GET_RELACIONES_DEV'
const PUT_RELACIONES_DEV = 'PUT_RELACIONES_DEV'
const GET_SOLICITUD_EDITAR_DEV = 'GET_SOLICITUD_EDITAR_DEV'
//MÉTODOS 

export const buscarSolicitudByFolio = createAsyncThunk(
    GET_SOLICITUDES_DEV,
    async (folio) => {
        try {
            const fullUrl = host + `SolicitudesDev/BuscarSolicitudByFolio`
            const res = await axios.post(fullUrl, { data: folio })
            return res.data.data
        } catch (error) {
            console.log(error.res);
        }
    }
)
export const ActualizarSolicitud = createAsyncThunk(
    PUT_SOLICITUDES_DEV,
    async (data) => {
        try {
            const fullUrl = host + `SolicitudesDev/ActualizarSolicitud`
            const res = await axios.post(fullUrl, { data: data })
            return res.data.data
        } catch (error) {
            console.log(error.res);
        }
    }
)
export const obtenerTodosClientesDev = createAsyncThunk(
    GET_CLIENTES_DEV,
    async (folio) => {
        try {
            const fullUrl = host + `InformacionValida/obtenerAllCliente`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error.res);
        }
    }
)
export const actualizarClientesDev = createAsyncThunk(
    PUT_CLIENTES_DEV,
    async (data) => {
        try {
            console.log('lo que llega es ', data)
            const fullUrl = host + `InformacionValida/actualizarCliente`
            for (const i in data) {
                let cliente = data[i]
                if (cliente.numerosocio.length == 4) {
                    let numerosocio = await formatNum(Number(cliente.numerosocio), 5)
                    let dataI = { idcliente: cliente.idcliente, numerosocio: numerosocio }
                    let respuesta = await axios.put(fullUrl, { data: dataI })
                    console.log('los datos es ', respuesta)
                }
            }
            return res.data.data
        } catch (error) {
            console.log(error.res);
        }
    }
)
export const obtenerTodasRelacionesDev = createAsyncThunk(
    GET_RELACIONES_DEV,
    async (folio) => {
        try {
            const fullUrl = host + `AtencionAClientes/obtenerTodasRelaciones`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error.res);
        }
    }
)

export const actualizarRelacionesDev = createAsyncThunk(
    PUT_RELACIONES_DEV,
    async (data) => {
        try {
            console.log('lo que llega es ', data)
            const fullUrl = host + `AtencionAClientes/actualizarRelacion`

            for (const i in data) {
                let relacion = data[i]

                let envasado = null
                let productor = null
                let numerosocio = null

                if (relacion?.envasado != null && relacion?.envasado?.length > 0) envasado = await formatNum(Number(relacion.envasado), 5)
                if (relacion?.productor != null && relacion?.productor?.length > 0) productor = await formatNum(Number(relacion.productor), 5)
                if (relacion?.numerosocio != null && relacion?.numerosocio?.length > 0) numerosocio = await formatNum(Number(relacion.numerosocio), 5)

                let dataRelacion = {
                    idrelacionclientes: relacion?.idrelacionclientes, envasado: envasado,
                    productor: productor, numerosocio: numerosocio
                }
                let respuesta = await axios.put(fullUrl, { data: dataRelacion })
                console.log('los datos es ', respuesta)

            }
            return res.data.data
        } catch (error) {
            console.log(error.res);
        }
    }
)
const formatNum = async (number, len) => "0".repeat(len - number.toString().length) + number.toString()

export const obtenerSolicitudEditarDev = createAsyncThunk(
    GET_SOLICITUD_EDITAR_DEV,
    async ({ folio, tipoSolicitud }) => {
        try {
            const fullUrl = `${host}SolicitudesDev/obtenerSolicitudEditarDev?folio=${folio}&tipoSolicitud=${tipoSolicitud}`;
            const res = await axios.get(fullUrl);
            return res;
        } catch (error) {
            console.log(error.response || error);
            throw error;
        }
    }
);
export const SolicitudesDevSlice = createSlice({

    name: 'SolicitudesDevSlice',
    initialState: dataInicial,
    reducers: {
    },
    extraReducers: {
        [buscarSolicitudByFolio.fulfilled]: (state, { payload }) => {
            state.solicitudesDev = payload
        },
    },

})


export const { } = SolicitudesDevSlice.actions
export const UsuarioDeveloperReducer = SolicitudesDevSlice.reducer